import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import SingleUser from './pages/SingleUser';
import Reports from './pages/Reports';
import Messages from './pages/Messages';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Students from './pages/Students';
import EnterScores from './pages/EnterScores';
import StudentSingleResult from './pages/StudentSingleResult';
import EnterClassResult from './pages/EnterClassResult';
import EditProfile from './pages/EditProfile';
import Attendance from './pages/Attendance';
// import LMSDashboard from './pages/lms/LMSDashboard';
// import CreateLesson from './pages/lms/CreateLesson';
// import LessonsList from './pages/lms/LessonsList';
// import LessonDetails from './pages/lms/LessonDetails';
// import EditLesson from './pages/lms/EditLesson';
import FormTeacherStudentsByClass from './pages/FormTeacherStudentsByClass';

// Protected route component that checks Redux auth state
const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  
  // Check if user is logged in and has a valid token
  const token = localStorage.getItem('authToken');
  
  if (!isLoggedIn || !token || !user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Public route component (for login page)
const PublicRoute = ({ children }) => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const token = localStorage.getItem('authToken');
  
  // If user is already logged in, redirect to dashboard
  if (isLoggedIn && token && user) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="form-teacher-students/:classId" element={<FormTeacherStudentsByClass />} />
          <Route path="students/:classId" element={<Students />} />
          <Route path="student/:id" element={<SingleUser />} />
          <Route path="enter-scores/:studentUuid/:classUuid/:subjectId" element={<EnterScores />} />
          <Route path="student-single-result" element={<StudentSingleResult />} />
          <Route path="results" element={<EnterClassResult />} />
          <Route path="classes" element={<Users />} />

          {/* LMS routes */}
          {/* <Route path="/lms" element={<LMSDashboard />} /> */}
          {/* <Route path="/lms/lessons" element={<LessonsList />} /> */}
          {/* <Route path="/lms/create" element={<CreateLesson />} /> */}
          {/* <Route path="/lms/lesson/:id" element={<LessonDetails />} /> */}
          {/* <Route path="/lms/edit/:id" element={<EditLesson />} /> */}

          <Route path="reports" element={<Reports />} />
          <Route path="assignments" element={<Messages />} />
          <Route path="grades" element={<Reports />} />
          <Route path="reports" element={<Reports />} />
          <Route path="messages" element={<Messages />} />
          <Route path="profile" element={<EditProfile />} />
          <Route path="settings" element={<Settings />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
